<h3 class="ai-coach">
  <span class="label">{{ 'AI Coach' | translate | async }}</span>
  @if (isBeta) {
    <span class="flag-beta">{{ 'BETA' | translate | async }}</span>
  }
</h3>
